<div class="layout">
  <div class="main scroll w-100 no-auth">
    <div class="container">
      <i-feather
        (click)="themeService.theme = themeService.theme == 'dark' ? '' : 'dark'; themeService.changeTheme(true)"
        name="eye"
        class="themeToggle invert d-none d-sm-block"
      ></i-feather>
      <div class="row align-items-center justify-content-center vh-100 py-7 py-lg-12">
        <div class="col col-lg-9 col-md-11">
         <!-- <app-modal-add-account></app-modal-add-account>-->
          <app-sign-fellowdesk></app-sign-fellowdesk>

        </div>
      </div>
    </div>
  </div>
</div>
